import script from "./AddressBlockTron.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressBlockTron.vue?vue&type=script&setup=true&lang=js"

import "./AddressBlockTron.vue?vue&type=style&index=0&id=5bc4a00a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc4a00a"]])

export default __exports__